import { PublicApiClient } from "../../apiClient/publicApiClient";

export type ApplicationTopicOptions = ApplicationTopicGroup[];

export interface ApplicationTopicGroup {
    name: string;
    children: ApplicationTopicOption[];
}

export interface ApplicationTopicOption {
    id: number;
    name: string;
    children?: ApplicationTopicGroup[];
}

/**
 * Fetch application topic options from the API.
 * @param apiClient PublicApiClient instance to make the request
 * @param country string | null - The country for which to fetch application topic options
 * The API will return options based on the provided country. for some countries, it may return an empty array.
 * @returns ApplicationTopicOptions
 */
export const getApplicationTopicOptions = async (
    apiClient: PublicApiClient,
    country: string | null
): Promise<ApplicationTopicOptions> => {
    return apiClient.request<ApplicationTopicOptions>("/servicecall/getapplicationtopicoptions", {
        mockResponse: mockApplicationTopicOptions,
        body: { country }
    });
};

const mockApplicationTopicOptions: ApplicationTopicOptions = [
    {
        name: "Applikation",
        children: [
            {
                id: 1,
                name: "Schweißen",
                children: [
                    {
                        name: "Optik",
                        children: [
                            {
                                id: 7,
                                name: "Festoptik BEO"
                            },
                            {
                                id: 8,
                                name: "PFO20/33"
                            },
                            {
                                id: 9,
                                name: "PFO 3D"
                            },
                            {
                                id: 10,
                                name: "I-PFO"
                            },
                            {
                                id: 11,
                                name: "Sonstiges"
                            }
                        ]
                    },
                    {
                        name: "Applikationsproblem",
                        children: [
                            {
                                id: 12,
                                name: "Einschweißtiefe"
                            },
                            {
                                id: 13,
                                name: "Festigkeit"
                            },
                            {
                                id: 14,
                                name: "Rissbildung"
                            },
                            {
                                id: 15,
                                name: "Lunker/Spritzer"
                            },
                            {
                                id: 16,
                                name: "Prozessdaten"
                            },
                            {
                                id: 17,
                                name: "Sonstiges"
                            }
                        ]
                    }
                ]
            },
            {
                id: 2,
                name: "Kunststoff"
            },
            {
                id: 3,
                name: "Schneiden"
            },
            {
                id: 4,
                name: "Härten"
            },
            {
                id: 5,
                name: "Beschriften"
            },
            {
                id: 6,
                name: "Sonstiges"
            }
        ]
    }
];
